import { render, staticRenderFns } from "./bugTable.vue?vue&type=template&id=8c53b8fc&scoped=true"
import script from "./bugTable.vue?vue&type=script&lang=ts"
export * from "./bugTable.vue?vue&type=script&lang=ts"
import style0 from "./bugTable.vue?vue&type=style&index=0&id=8c53b8fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c53b8fc",
  null
  
)

export default component.exports